import React from "react";
import { useNavigate } from "react-router-dom";
import CareProfileForm from "../components/profiles/CareProfileForm";
import { useAuth } from "../contexts/AuthContext";

const CreateProfilePage = () => {
  const { currentUser } = useAuth();
  const navigate = useNavigate();

  // This function will be called on successful profile creation
  const handleSuccess = () => {
    navigate("/profiles");
  };

  return (
    <div className="container mx-auto p-4">
      <div className="max-w-lg mx-auto bg-white p-8 rounded-lg shadow-md">
        <h1 className="text-2xl font-bold mb-6 text-center">
          Set Up Your Family Health Profile
        </h1>
        <p className="text-gray-600 mb-6 text-center">
          Welcome to MILA Care. Start by creating a health profile for yourself
          or a family member. Your name has been pre-filled below.
        </p>
        <CareProfileForm
          isInitialProfile={true}
          initialProfileName={currentUser?.displayName || ""}
          onFormSubmit={handleSuccess} // Use onFormSubmit to trigger navigation
        />
      </div>
    </div>
  );
};

export default CreateProfilePage;
